import apiClient from "./apiClient";

export const listAdminUsers = () => apiClient.get("/admin/users");
export const createAdminUser = (payload) => apiClient.post("/admin/users", payload);
export const getAccessConfig = () => apiClient.get("/admin/access-config");
export const getAdminUserDetail = (userId) => apiClient.get(`/admin/users/${userId}`);
export const updateAdminUserAccess = (userId, payload) =>
  apiClient.patch(`/admin/users/${userId}/access`, payload);
export const updateUserRole = (userId, role) =>
  apiClient.patch(`/admin/users/${userId}/role`, { role });
export const updateUserStatus = (userId, status) =>
  apiClient.patch(`/admin/users/${userId}/status`, { status });
export const resetUserPassword = (userId) =>
  apiClient.patch(`/admin/users/${userId}/reset-password`);
export const confirmPasswordReset = (token, newPassword) =>
  apiClient.post("/auth/reset-password/confirm", { token, new_password: newPassword });

export const listCommittees = () => apiClient.get("/committees");
export const createCommittee = (payload) => apiClient.post("/committees", payload);
export const addCommitteeMembers = (committeeId, userIds) =>
  apiClient.post(`/committees/${committeeId}/members`, { user_ids: userIds });
export const removeCommitteeMember = (committeeId, userId) =>
  apiClient.delete(`/committees/${committeeId}/members/${userId}`);

export const listAdminAuditLogs = (params = {}) =>
  apiClient.get("/admin/audit-logs", { params });
